import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/src/app/app.config';
import { AppComponent } from '@app/src/app/components/app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
